import { slitting } from './Slitting';
import { lamination } from './Lamination';

export const convertStep = { lamination, slitting }